module.exports = __webpack_public_path__ + "img/thermometr-light.025afb5e.svg";